import { gql } from "graphql-tag";

export const GET_ANALYTICS_DEDUCTIONS_BY_RETAILER = gql`
  query AnalyticsDeductionsByRetailer($params: GetAnalyticsInput!) {
    analyticsDeductionsByRetailer(params: $params) {
      totalAmount
      retailers {
        retailer {
          retailerId
          retailerKey
          retailerName
        }
        amount
        count
        share
        vsPrior
        trend
      }
    }
  }
`;
